import { SelectedContourValueProps, TTSInstance } from "./tts";
import { SelectorOptionsWithTooltip } from "./selector";

export const initialTTSInstance: TTSInstance = {
  selectedEnv: "",
  selectedDeployment: "",
  selectedSampleRate: "",
  selectedLanguage: "",
  selectedVoice: "annie",
};

export const defaultContourValues: SelectedContourValueProps[] = [
  { index: 0, data: { time: 0, value: 0 } }, // dummy data for graph, will not be used in the final contour tag
  { index: 1, data: { time: 20, value: 0 } },
  { index: 2, data: { time: 50, value: 0 } },
  { index: 3, data: { time: 80, value: 0 } },
  { index: 4, data: { time: 100, value: 0 } }, // dummy data for graph, will not be used in the final contour tag
];

export const defaultSampleRates: SelectorOptionsWithTooltip = [
  { value: "22050", name: "22.050 Hz" },
  { value: "44100", name: "44.100 Hz" },
  { value: "48000", name: "48.000 Hz" },
];
